import React, { useState } from 'react'
import { Button } from '../../components/ui/button'
import { NumericInput } from '@blueprintjs/core'

export const SinkNumeric = ({}) => {
    const [value, setValue] = useState<number | string>(50)

    return (
        <div className="p-6">
            <label>Old</label>
            <NumericInput
                disabled={false}
                minorStepSize={0.01}
                stepSize={0.01}
                majorStepSize={0.01}
                leftIcon={<Button minimal text={window.marketplace.currency_symbol} />}
                value={value}
                onValueChange={(_, value) => setValue(value)}
                buttonPosition="none"
            />
        </div>
    )
}
